import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaGithub, FaExternalLinkAlt, FaCode, FaArrowRight } from 'react-icons/fa';

const ProjectCard = ({ project, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="group glass rounded-2xl overflow-hidden hover:bg-white/10 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:shadow-primary-500/10"
    >
      {/* Image */}
      <div className="relative h-48 bg-gradient-to-br from-primary-500/20 to-accent-500/20 overflow-hidden">
        {project.hero_image ? (
          <img 
            src={project.hero_image} 
            alt={project.title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <FaCode className="text-5xl text-white/20" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-dark-950 via-transparent to-transparent" />
        
        {/* Category Badge */}
        {project.category && (
          <span className="absolute top-3 right-3 px-3 py-1 text-xs rounded-full bg-primary-500/80 text-white backdrop-blur-sm">
            {project.category}
          </span>
        )}
        
        {project.featured && (
          <span className="absolute top-3 left-3 px-3 py-1 text-xs rounded-full bg-accent-500/80 text-white backdrop-blur-sm">
            Featured
          </span>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-semibold text-white mb-2 group-hover:text-primary-400 transition-colors duration-300">
          {project.title}
        </h3>
        
        <p className="text-gray-400 text-sm mb-4 line-clamp-2">
          {project.description}
        </p>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-2 mb-4">
          {project.tech_stack && project.tech_stack.slice(0, 4).map((tech, i) => (
            <span 
              key={i}
              className="px-2 py-1 text-xs rounded-md bg-white/5 border border-white/10 text-gray-400"
            >
              {tech}
            </span>
          ))}
          {project.tech_stack && project.tech_stack.length > 4 && (
            <span className="px-2 py-1 text-xs rounded-md bg-white/5 border border-white/10 text-gray-400">
              +{project.tech_stack.length - 4}
            </span>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between">
          <div className="flex gap-2">
            {project.github_url && (
              <a 
                href={project.github_url}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaGithub size={16} />
              </a>
            )}
            {project.live_url && (
              <a 
                href={project.live_url}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-all duration-300 text-gray-400 hover:text-white"
              >
                <FaExternalLinkAlt size={16} />
              </a>
            )}
          </div>
          
          <Link 
            to={`/projects/${project.slug || project.id}`}
            className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-300"
          >
            View Details
            <FaArrowRight size={12} />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;